module.exports = __webpack_public_path__ + "img/utilityhydrant_stopped.eb8330ec.svg";